var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"csr-checkbox-policy"},[_c('FormItem',_vm._b({attrs:{"hide-label":true}},'FormItem',_setup.state.conf,false),[_c('MdCheckbox',_vm._b({on:{"change":_setup.handleChange},model:{value:(_setup.state.value),callback:function ($$v) {_vm.$set(_setup.state, "value", $$v)},expression:"state.value"}},'MdCheckbox',{
          ..._vm.$attrs,
          ..._setup.state.conf
        },false),[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }